import { render, staticRenderFns } from "./OrderCart.vue?vue&type=template&id=ddba14ae&scoped=true&"
import script from "./OrderCart.vue?vue&type=script&lang=js&"
export * from "./OrderCart.vue?vue&type=script&lang=js&"
import style0 from "./OrderCart.vue?vue&type=style&index=0&id=ddba14ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddba14ae",
  null
  
)

export default component.exports